import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivationEnd,
  NavigationEnd,
  Router,
  Scroll,
} from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, map, shareReplay, startWith, takeUntil } from 'rxjs/operators';

import { AnalyticsService } from '@digital-platform/analytics/services';
import {
  GlobalAlertService,
  TitleService,
} from '@digital-platform/shared/services';
import { LoginSessionFacadeService } from '@digital-platform/users/services';
// import { ConfirmModalService } from '@digital-platform/waste-profiles/feature-confirm-legacy-profile';

@Component({
  selector: 'digital-platform-ries-hub-ui-shell',
  templateUrl: './ries-hub-ui-shell.component.html',
  styleUrls: ['./ries-hub-ui-shell.component.scss'],
  // providers: [ConfirmModalService],
})
export class RiesHubUiShellComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void>;
  public loggedIn$: Observable<boolean>;
  public expanded = true;
  public pageName: string;
  public loggedIn: boolean;
  public routeLoading = true;
  public titleService = inject(TitleService);

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,

    private analyticsService: AnalyticsService,
    private alertService: GlobalAlertService,
    // ALERT (pa - 07Dec 2023): removing this cuz it isn't being used anywhere, and it is causing problems for scale attendant users
    // who lack waste profile permissions. ConfirmModalService contains a WasteProfileFacadeService which causes the issue. shouldn't
    // initialize stuff we don't need
    // private confirmModalService: ConfirmModalService, // global init
    private loginSessionFacade: LoginSessionFacadeService
  ) {
    this.destroyed$ = new Subject<void>();

    this.loggedIn$ = this.loginSessionFacade.loginSession$.pipe(
      map((loginSession) => {
        let loggedIn = true;
        if (loginSession === null || loginSession?.user === null) {
          loggedIn = false;
          this.loggedIn = false;
          console.log('setting routeloading = true');
          this.routeLoading = true;
          this.expanded = true; // Make sure to start next session with expanded nav
        } else if (loginSession?.user?.requirePasswordReset) {
          loggedIn = false;
        }
        this.loggedIn = loggedIn;
        return loggedIn;
      }),
      shareReplay(1)
    );

    this.router.events.subscribe((event) => {
      if (
        event instanceof ActivationEnd &&
        event.snapshot.component &&
        !(event.snapshot.component === RiesHubUiShellComponent)
      ) {
        this.titleService.setPageName(event.snapshot.data.pageName);
      }
      if (
        this.loggedIn &&
        (event instanceof NavigationEnd ||
          (event instanceof Scroll && // In case of reload or hot reload this is final event that has login data
            event.routerEvent instanceof NavigationEnd))
      ) {
        this.routeLoading = false;
      }
    });
  }

  ngOnInit(): void {
    this.alertService.checkForAlerts();
    // grabs the url from the navigation end event and sets it on analytics, and starts with
    // the current url from the location service, as on initial page load there is no event to use
    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        filter((event) => event instanceof NavigationEnd),
        startWith(''), // startWith here lets us kick one off on load b/c the event doesn't fire on page load
        map(() => this.activatedRoute), // switches the stream to the current activated route
        map((route) => {
          // traverse down the route tree to the last activated route
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        map(
          (route) =>
            '/' +
            route.pathFromRoot
              .map((item) => {
                let path = item.snapshot.routeConfig?.path || '';
                // pull route params we want to track into the generated path
                if (path.match(/:step/) && item.snapshot.params.step) {
                  path = path.replace(/:step/, item.snapshot.params.step);
                }
                return path;
              })
              .filter((item) => !!item)
              .join('/')
        )
      )
      .subscribe((pageName) =>
        this.analyticsService.registerPageName(pageName)
      );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  adjustFlex = (event) => {
    console.log('adjustFlex', event);
    this.expanded = !this.expanded;
  };
}
